import Typography from "@material-ui/core/esm/Typography";
import clsx from 'clsx';
import React from 'react';
import useStyles from './TextStyles';
export default function Info({
  children,
  align,
  className,
  isBold
}) {
  const {
    info,
    bold
  } = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    align: align,
    className: clsx(info, className, {
      [bold]: isBold
    }),
    variant: "body1"
  }, children);
}
Info.defaultProps = {
  align: 'left',
  isBold: false
};